import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enl-example-ng6-lib',
  template: `
    <p>
      example-ng6-lib works!
    </p>
  `,
  styles: []
})
export class ExampleNg6LibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
